import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import "../intl.js";
import t from "../core/Collection.js";
import { eventKey as i } from "../core/events.js";
import o from "../core/Handles.js";
import n from "../core/Logger.js";
import { isNone as s } from "../core/maybe.js";
import { throttle as r } from "../core/throttle.js";
import { watch as a, whenFalse as l, on as u, init as c } from "../core/watchUtils.js";
import { aliasOf as d } from "../core/accessorSupport/decorators/aliasOf.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import { cast as p } from "../core/accessorSupport/decorators/cast.js";
import { property as h } from "../core/accessorSupport/decorators/property.js";
import { subclass as g } from "../core/accessorSupport/decorators/subclass.js";
import _ from "./Feature.js";
import f from "./Spinner.js";
import v from "./Widget.js";
import { FeatureContentMixin as m } from "./Feature/support/FeatureContentMixin.js";
import b from "./Popup/PopupViewModel.js";
import { Heading as M } from "./support/Heading.js";
import { accessibleHandler as w } from "./support/decorators/accessibleHandler.js";
import { messageBundle as y } from "./support/decorators/messageBundle.js";
import { vmEvent as k } from "./support/decorators/vmEvent.js";
import { tsx as C } from "./support/jsxFactory.js";
import { isRTL as A, storeNode as F, cssTransition as I } from "./support/widgetUtils.js";
import { substitute as O } from "../intl/substitute.js";
var x = "selected-index",
    N = 0,
    B = "popup-spinner",
    T = {
  iconLeftTriangleArrow: "esri-icon-left-triangle-arrow",
  iconRightTriangleArrow: "esri-icon-right-triangle-arrow",
  iconDockToTop: "esri-icon-maximize",
  iconDockToBottom: "esri-icon-dock-bottom",
  iconDockToLeft: "esri-icon-dock-left",
  iconDockToRight: "esri-icon-dock-right",
  iconClose: "esri-icon-close",
  iconUndock: "esri-icon-minimize",
  iconCheckMark: "esri-icon-check-mark",
  iconLoading: "esri-icon-loading-indicator",
  iconDefaultAction: "esri-icon-default-action",
  iconActionsMenu: "esri-icon-handle-horizontal",
  rotating: "esri-rotating",
  base: "esri-popup",
  widget: "esri-widget",
  main: "esri-popup__main-container",
  loadingContainer: "esri-popup__loading-container",
  isCollapsible: "esri-popup--is-collapsible",
  isCollapsed: "esri-popup--is-collapsed",
  shadow: "esri-popup--shadow",
  isDocked: "esri-popup--is-docked",
  isDockedTopLeft: "esri-popup--is-docked-top-left",
  isDockedTopCenter: "esri-popup--is-docked-top-center",
  isDockedTopRight: "esri-popup--is-docked-top-right",
  isDockedBottomLeft: "esri-popup--is-docked-bottom-left",
  isDockedBottomCenter: "esri-popup--is-docked-bottom-center",
  isDockedBottomRight: "esri-popup--is-docked-bottom-right",
  alignTopCenter: "esri-popup--aligned-top-center",
  alignBottomCenter: "esri-popup--aligned-bottom-center",
  alignTopLeft: "esri-popup--aligned-top-left",
  alignBottomLeft: "esri-popup--aligned-bottom-left",
  alignTopRight: "esri-popup--aligned-top-right",
  alignBottomRight: "esri-popup--aligned-bottom-right",
  isFeatureMenuOpen: "esri-popup--feature-menu-open",
  isActionsMenuOpen: "esri-popup--actions-menu-open",
  hasFeatureUpdated: "esri-popup--feature-updated",
  header: "esri-popup__header",
  headerButtons: "esri-popup__header-buttons",
  headerContainer: "esri-popup__header-container",
  headerContainerButton: "esri-popup__header-container--button",
  headerTitle: "esri-popup__header-title",
  content: "esri-popup__content",
  footer: "esri-popup__footer",
  footerHasPagination: "esri-popup__footer--has-pagination",
  footerHasActions: "esri-popup__footer--has-actions",
  footerHasActionsMenu: "esri-popup__footer--has-actions-menu",
  button: "esri-popup__button",
  buttonDisabled: "esri-popup__button--disabled",
  buttonDock: "esri-popup__button--dock",
  icon: "esri-popup__icon",
  iconDock: "esri-popup__icon--dock-icon",
  inlineActionsContainer: "esri-popup__inline-actions-container",
  actionsMenuButton: "esri-popup__actions-menu-button",
  actions: "esri-popup__actions",
  action: "esri-popup__action",
  actionImage: "esri-popup__action-image",
  actionText: "esri-popup__action-text",
  actionToggle: "esri-popup__action-toggle",
  actionToggleOn: "esri-popup__action-toggle--on",
  pointer: "esri-popup__pointer",
  pointerDirection: "esri-popup__pointer-direction",
  navigation: "esri-popup__navigation",
  paginationPrevious: "esri-popup__pagination-previous",
  paginationNext: "esri-popup__pagination-next",
  paginationPreviousIconLTR: "esri-popup__pagination-previous-icon",
  paginationPreviousIconRTL: "esri-popup__pagination-previous-icon--rtl",
  paginationNextIconLTR: "esri-popup__pagination-next-icon",
  paginationNextIconRTL: "esri-popup__pagination-next-icon--rtl",
  featureMenu: "esri-popup__feature-menu",
  featureMenuList: "esri-popup__feature-menu-list",
  featureMenuItem: "esri-popup__feature-menu-item",
  featureMenuViewport: "esri-popup__feature-menu-viewport",
  featureMenuHeader: "esri-popup__feature-menu-header",
  featureMenuNote: "esri-popup__feature-menu-note",
  featureMenuSelected: "esri-popup__feature-menu-item--selected",
  featureMenuButton: "esri-popup__feature-menu-button",
  featureMenuTitle: "esri-popup__feature-menu-title",
  featureMenuObserver: "esri-popup__feature-menu-observer",
  featureMenuLoader: "esri-popup__feature-menu-loader",
  collapseButton: "esri-popup__collapse-button"
},
    D = {
  buttonEnabled: !0,
  position: "auto",
  breakpoint: {
    width: 544
  }
},
    E = "esri-popup";

function P(e, t) {
  return void 0 === t ? "".concat(E, "__").concat(e) : "".concat(E, "__").concat(e, "-").concat(t);
}

var L = "esri.widgets.Popup",
    S = n.getLogger(L),
    V = {
  closeButton: !0,
  featureNavigation: !0
};

var U = /*#__PURE__*/function (_m) {
  _inherits(U, _m);

  var _super = _createSuper(U);

  function U(e, t) {
    var _this;

    _classCallCheck(this, U);

    _this = _super.call(this, e, t), _this._blurClose = !1, _this._blurContainer = !1, _this._containerNode = null, _this._mainContainerNode = null, _this._featureMenuNode = null, _this._actionsMenuNode = null, _this._focusClose = !1, _this._focusContainer = !1, _this._focusDockButton = !1, _this._focusFeatureMenuButton = !1, _this._focusActionsMenuButton = !1, _this._focusFirstFeature = !1, _this._focusFirstAction = !1, _this._handles = new o(), _this._pointerOffsetInPx = 16, _this._spinner = null, _this._feature = null, _this._featureMenuIntersectionObserverCallback = function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          e = _ref2[0];

      null != e && e.isIntersecting && _this.viewModel.featurePage++;
    }, _this._featureMenuIntersectionObserver = new IntersectionObserver(_this._featureMenuIntersectionObserverCallback, {
      root: window.document
    }), _this._displaySpinnerThrottled = r(function () {
      return _this._displaySpinner();
    }, N), _this.actions = null, _this.alignment = "auto", _this.autoCloseEnabled = null, _this.autoOpenEnabled = null, _this.defaultPopupTemplateEnabled = null, _this.content = null, _this.collapsed = !1, _this.collapseEnabled = !0, _this.dockEnabled = !1, _this.featureCount = null, _this.featureMenuOpen = !1, _this.features = null, _this.goToOverride = null, _this.headingLevel = 2, _this.highlightEnabled = null, _this.location = null, _this.label = void 0, _this.maxInlineActions = 3, _this.messages = null, _this.messagesCommon = null, _this.promises = null, _this.selectedFeature = null, _this.selectedFeatureIndex = null, _this.spinnerEnabled = !0, _this.title = null, _this.updateLocationEnabled = null, _this.view = null, _this.viewModel = new b(), _this.visible = null, _this.visibleElements = _objectSpread({}, V), _this._addSelectedFeatureIndexHandle(), _this.own([a(_assertThisInitialized(_this), "viewModel.screenLocation", function () {
      return _this._positionContainer();
    }), a(_assertThisInitialized(_this), ["viewModel.active", "dockEnabled"], function () {
      return _this._toggleScreenLocationEnabled();
    }), a(_assertThisInitialized(_this), "viewModel.screenLocation", function (e, t) {
      !!e != !!t && _this.reposition();
    }), a(_assertThisInitialized(_this), ["viewModel.view.padding", "viewModel.view.size", "viewModel.active", "viewModel.location", "alignment"], function () {
      return _this.reposition();
    }), a(_assertThisInitialized(_this), "spinnerEnabled", function (e) {
      return _this._spinnerEnabledChange(e);
    }), a(_assertThisInitialized(_this), "viewModel.view.size", function (e, t) {
      return _this._updateDockEnabledForViewSize(e, t);
    }), a(_assertThisInitialized(_this), "viewModel.view", function (e, t) {
      return _this._viewChange(e, t);
    }), a(_assertThisInitialized(_this), "viewModel.view.ready", function (e, t) {
      return _this._viewReadyChange(e, t);
    }), a(_assertThisInitialized(_this), ["viewModel.waitingForResult", "viewModel.location"], function () {
      _this._hideSpinner(), _this._displaySpinnerThrottled();
    }), a(_assertThisInitialized(_this), ["selectedFeatureWidget.viewModel.title", "selectedFeatureWidget.viewModel.state"], function () {
      return _this._setTitleFromFeatureWidget();
    }), a(_assertThisInitialized(_this), ["selectedFeatureWidget.viewModel.content", "selectedFeatureWidget.viewModel.state"], function () {
      return _this._setContentFromFeatureWidget();
    }), l(_assertThisInitialized(_this), "collapsed", function () {
      var e, t;
      "xsmall" === (null == (e = _this.viewModel) || null == (t = e.view) ? void 0 : t.widthBreakpoint) && _this.viewModel.active && _this.collapseEnabled && _this.viewModel.centerAtLocation();
    }), u(_assertThisInitialized(_this), "viewModel.allActions", "change", function () {
      return _this._watchActions();
    }), c(_assertThisInitialized(_this), "viewModel.allActions", function () {
      return _this._watchActions();
    }), a(_assertThisInitialized(_this), "viewModel.featureViewModels", function () {
      return _this._featureMenuViewportScrollTop();
    })]);
    return _this;
  }

  _createClass(U, [{
    key: "destroy",
    value: function destroy() {
      var e, t;
      this._destroySelectedFeatureWidget(), this._destroySpinner(), null == (e = this._handles) || e.destroy(), this._unobserveFeatureMenuObserver(), null == (t = this._featureMenuIntersectionObserver) || t.disconnect(), this._handles = null;
    }
  }, {
    key: "actionsMenuId",
    get: function get() {
      return "".concat(this.id, "-actions-menu");
    }
  }, {
    key: "actionsMenuButtonId",
    get: function get() {
      return "".concat(this.id, "-actions-menu-button");
    }
  }, {
    key: "featureMenuId",
    get: function get() {
      return "".concat(this.id, "-feature-menu");
    }
  }, {
    key: "titleId",
    get: function get() {
      return "".concat(this.id, "-popup-title");
    }
  }, {
    key: "contentId",
    get: function get() {
      return "".concat(this.id, "-popup-content");
    }
  }, {
    key: "hasContent",
    get: function get() {
      var e, t, i, o, n, s, r;
      return !!(this.selectedFeatureWidget ? (null == (e = this.selectedFeatureWidget) || null == (t = e.viewModel) ? void 0 : t.waitingForContent) || "error" === (null == (i = this.selectedFeatureWidget) || null == (o = i.viewModel) ? void 0 : o.state) || (null == (n = this.selectedFeatureWidget) || null == (s = n.viewModel) ? void 0 : s.content) : null == (r = this.viewModel) ? void 0 : r.content);
    }
  }, {
    key: "featureNavigationVisible",
    get: function get() {
      return this.viewModel.active && this.viewModel.featureCount > 1 && this.visibleElements.featureNavigation;
    }
  }, {
    key: "collapsible",
    get: function get() {
      return !!(this.collapseEnabled && this.viewModel.title && this.hasContent);
    }
  }, {
    key: "featureMenuVisible",
    get: function get() {
      return this.featureNavigationVisible && this.featureMenuOpen;
    }
  }, {
    key: "contentCollapsed",
    get: function get() {
      return this.collapsible && !this.featureMenuVisible && this.collapsed;
    }
  }, {
    key: "dividedActions",
    get: function get() {
      return this._divideActions();
    }
  }, {
    key: "actionsMenuOpen",
    get: function get() {
      return !!this.viewModel.active && this._get("actionsMenuOpen");
    },
    set: function set(e) {
      this._set("actionsMenuOpen", !!e);
    }
  }, {
    key: "currentAlignment",
    get: function get() {
      return this._getCurrentAlignment();
    }
  }, {
    key: "currentDockPosition",
    get: function get() {
      return this._getCurrentDockPosition();
    }
  }, {
    key: "dockOptions",
    get: function get() {
      return this._get("dockOptions") || D;
    },
    set: function set(e) {
      var t = _objectSpread({}, D),
          i = this.get("viewModel.view.breakpoints"),
          o = {};

      i && (o.width = i.xsmall, o.height = i.xsmall);

      var n = _objectSpread(_objectSpread({}, t), e),
          s = _objectSpread(_objectSpread({}, t.breakpoint), o),
          r = n.breakpoint;

      !0 === r ? n.breakpoint = s : "object" == typeof r && (n.breakpoint = _objectSpread(_objectSpread({}, s), r)), this._set("dockOptions", n), this._setCurrentDockPosition(), this.reposition();
    }
  }, {
    key: "selectedFeatureWidget",
    get: function get() {
      var e = this._feature,
          t = this.visibleElements,
          i = this.headingLevel,
          o = this.viewModel.selectedFeatureViewModel,
          n = _objectSpread(_objectSpread({}, t), {}, {
        title: !1
      });

      return o ? (e ? (e.viewModel = o, e.visibleElements = n) : this._feature = new _({
        headingLevel: i + 1,
        viewModel: o,
        visibleElements: n
      }), this._feature) : null;
    }
  }, {
    key: "castVisibleElements",
    value: function castVisibleElements(e) {
      return _objectSpread(_objectSpread({}, V), e);
    }
  }, {
    key: "blur",
    value: function blur() {
      var e = this.viewModel.active;
      e || S.warn("Popup can only be blurred when currently active."), this.visibleElements.closeButton ? this._blurClose = !0 : this._blurContainer = !0, this.scheduleRender();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.viewModel.clear();
    }
  }, {
    key: "close",
    value: function close() {
      this.visible = !1;
    }
  }, {
    key: "fetchFeatures",
    value: function fetchFeatures(e, t) {
      return this.viewModel.fetchFeatures(e, t);
    }
  }, {
    key: "focus",
    value: function focus() {
      var e = this.viewModel.active;
      e || S.warn("Popup can only be focused when currently active."), this.visibleElements.closeButton ? this._focusClose = !0 : this._focusContainer = !0, this.scheduleRender();
    }
  }, {
    key: "next",
    value: function next() {
      return this.viewModel.next();
    }
  }, {
    key: "open",
    value: function open(e) {
      var t, i;

      this._handles.remove(x);

      var o = !!e && !!e.featureMenuOpen,
          n = !!e && !!e.actionsMenuOpen,
          s = {
        collapsed: !!e && !!e.collapsed,
        actionsMenuOpen: n,
        featureMenuOpen: o
      };
      "xsmall" === (null == (t = this.viewModel) || null == (i = t.view) ? void 0 : i.widthBreakpoint) && (s.collapsed = !0), this.set(s), this.viewModel.open(e), this._addSelectedFeatureIndexHandle();
    }
  }, {
    key: "previous",
    value: function previous() {
      return this.viewModel.previous();
    }
  }, {
    key: "reposition",
    value: function reposition() {
      this.renderNow(), this._positionContainer(), this._setCurrentAlignment();
    }
  }, {
    key: "triggerAction",
    value: function triggerAction(e) {
      this.viewModel.triggerAction(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _v;

      var e, t, i, o;

      var n = this.actionsMenuOpen,
          s = this.dockEnabled,
          r = this.featureMenuVisible,
          a = this.dividedActions,
          l = this.currentAlignment,
          u = this.currentDockPosition,
          c = this.viewModel.active,
          d = a.menuActions,
          p = c && d.length > 1 && n,
          h = c && s,
          g = c && !s,
          _ = null == (e = this.selectedFeature) || null == (t = e.layer) ? void 0 : t.title,
          f = null == (i = this.selectedFeature) || null == (o = i.layer) ? void 0 : o.id,
          v = (_v = {}, _defineProperty(_v, T.alignTopCenter, "top-center" === l), _defineProperty(_v, T.alignBottomCenter, "bottom-center" === l), _defineProperty(_v, T.alignTopLeft, "top-left" === l), _defineProperty(_v, T.alignBottomLeft, "bottom-left" === l), _defineProperty(_v, T.alignTopRight, "top-right" === l), _defineProperty(_v, T.alignBottomRight, "bottom-right" === l), _defineProperty(_v, T.isDocked, h), _defineProperty(_v, T.shadow, g), _defineProperty(_v, T.isDockedTopLeft, "top-left" === u), _defineProperty(_v, T.isDockedTopCenter, "top-center" === u), _defineProperty(_v, T.isDockedTopRight, "top-right" === u), _defineProperty(_v, T.isDockedBottomLeft, "bottom-left" === u), _defineProperty(_v, T.isDockedBottomCenter, "bottom-center" === u), _defineProperty(_v, T.isDockedBottomRight, "bottom-right" === u), _defineProperty(_v, T.isFeatureMenuOpen, r), _defineProperty(_v, T.isActionsMenuOpen, p), _v);

      return C("div", {
        class: this.classes(T.base, v),
        role: "presentation",
        "data-layer-title": _,
        "data-layer-id": f,
        bind: this,
        afterCreate: this._positionContainer,
        afterUpdate: this._positionContainer
      }, c ? [this.renderMainContainer(), this.renderPointer()] : null);
    }
  }, {
    key: "renderLoadingIcon",
    value: function renderLoadingIcon() {
      return C("span", {
        "aria-hidden": "true",
        class: this.classes(T.icon, T.iconLoading, T.rotating)
      });
    }
  }, {
    key: "renderNavigationLoading",
    value: function renderNavigationLoading() {
      var e = this.messagesCommon;
      return this.viewModel.pendingPromisesCount ? C("div", {
        key: P("loading-container"),
        role: "presentation",
        class: T.loadingContainer,
        "aria-label": e.loading,
        title: e.loading
      }, this.renderLoadingIcon()) : null;
    }
  }, {
    key: "renderPreviousIcon",
    value: function renderPreviousIcon() {
      var _t;

      var e = A(this.container),
          t = (_t = {}, _defineProperty(_t, T.iconRightTriangleArrow, e), _defineProperty(_t, T.paginationPreviousIconRTL, e), _defineProperty(_t, T.iconLeftTriangleArrow, !e), _defineProperty(_t, T.paginationPreviousIconLTR, !e), _t);
      return C("span", {
        "aria-hidden": "true",
        class: this.classes(T.icon, t)
      });
    }
  }, {
    key: "renderPreviousButton",
    value: function renderPreviousButton() {
      var e = this.messages;
      return C("div", {
        role: "button",
        tabIndex: 0,
        bind: this,
        onclick: this._previous,
        onkeydown: this._previous,
        class: this.classes(T.button, T.paginationPrevious),
        "aria-label": e.previous,
        title: e.previous
      }, this.renderPreviousIcon());
    }
  }, {
    key: "renderNextIcon",
    value: function renderNextIcon() {
      var _t2;

      var e = A(this.container),
          t = (_t2 = {}, _defineProperty(_t2, T.iconLeftTriangleArrow, e), _defineProperty(_t2, T.paginationNextIconRTL, e), _defineProperty(_t2, T.iconRightTriangleArrow, !e), _defineProperty(_t2, T.paginationNextIconLTR, !e), _t2);
      return C("span", {
        "aria-hidden": "true",
        class: this.classes(T.icon, t)
      });
    }
  }, {
    key: "renderNextButton",
    value: function renderNextButton() {
      var e = this.messages;
      return C("div", {
        role: "button",
        tabIndex: 0,
        bind: this,
        onclick: this._next,
        onkeydown: this._next,
        class: this.classes(T.button, T.paginationNext),
        "aria-label": e.next,
        title: e.next
      }, this.renderNextIcon());
    }
  }, {
    key: "renderFeatureMenuButton",
    value: function renderFeatureMenuButton() {
      var e = this.featureMenuOpen,
          t = this.featureMenuId,
          i = this.messagesCommon,
          _this$viewModel = this.viewModel,
          o = _this$viewModel.featureCount,
          n = _this$viewModel.selectedFeatureIndex;
      return C("div", {
        role: "button",
        tabIndex: 0,
        bind: this,
        onclick: this._toggleFeatureMenu,
        onkeydown: this._toggleFeatureMenu,
        afterCreate: this._focusFeatureMenuButtonNode,
        afterUpdate: this._focusFeatureMenuButtonNode,
        class: this.classes(T.button, T.featureMenuButton),
        "aria-haspopup": "true",
        "aria-controls": t,
        "aria-expanded": e.toString(),
        "aria-label": i.menu,
        title: i.menu
      }, this._getPageText(o, n));
    }
  }, {
    key: "renderNavigationButtons",
    value: function renderNavigationButtons() {
      return this.featureNavigationVisible ? [this.renderPreviousButton(), this.renderNavigationLoading() || this.renderFeatureMenuButton(), this.renderNextButton()] : null;
    }
  }, {
    key: "renderDockIcon",
    value: function renderDockIcon() {
      var _i;

      var e = this.dockEnabled,
          t = this._wouldDockTo(),
          i = (_i = {}, _defineProperty(_i, T.iconUndock, e), _defineProperty(_i, T.iconDock, !e), _defineProperty(_i, T.iconDockToRight, !e && ("top-right" === t || "bottom-right" === t)), _defineProperty(_i, T.iconDockToLeft, !e && ("top-left" === t || "bottom-left" === t)), _defineProperty(_i, T.iconDockToTop, !e && "top-center" === t), _defineProperty(_i, T.iconDockToBottom, !e && "bottom-center" === t), _i);

      return C("span", {
        "aria-hidden": "true",
        class: this.classes(i, T.icon)
      });
    }
  }, {
    key: "renderDockButton",
    value: function renderDockButton() {
      var e, t, i;
      var o = this.dockEnabled,
          n = this.messages,
          s = null == (e = this.viewModel) || null == (t = e.view) ? void 0 : t.widthBreakpoint,
          r = o ? n.undock : n.dock;
      return "xsmall" !== s && null != (i = this.dockOptions) && i.buttonEnabled ? C("div", {
        role: "button",
        "aria-label": r,
        title: r,
        tabIndex: 0,
        bind: this,
        onclick: this._toggleDockEnabled,
        onkeydown: this._toggleDockEnabled,
        afterCreate: this._focusDockButtonNode,
        afterUpdate: this._focusDockButtonNode,
        class: this.classes(T.button, T.buttonDock)
      }, this.renderDockIcon()) : null;
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var e = this.viewModel.title,
          t = this.titleId,
          i = this.collapsible,
          o = this.contentCollapsed,
          n = this.messagesCommon,
          s = _defineProperty({}, T.headerContainerButton, i),
          r = C(M, {
        level: this.headingLevel,
        class: T.headerTitle,
        innerHTML: e
      }),
          a = i ? C("button", {
        key: "".concat(e, "--collapsible"),
        id: t,
        title: o ? n.expand : n.collapse,
        bind: this,
        enterAnimation: this._createFeatureUpdatedAnimation(),
        class: this.classes(T.headerContainer, s),
        "aria-expanded": o ? "false" : "true",
        onclick: this._toggleCollapsed
      }, r) : C("div", {
        key: e,
        id: t,
        bind: this,
        enterAnimation: this._createFeatureUpdatedAnimation(),
        class: this.classes(T.headerContainer, s)
      }, r);

      return e ? a : null;
    }
  }, {
    key: "renderCloseIcon",
    value: function renderCloseIcon() {
      return C("span", {
        "aria-hidden": "true",
        class: this.classes(T.icon, T.iconClose)
      });
    }
  }, {
    key: "renderCloseButton",
    value: function renderCloseButton() {
      var e = this.visibleElements,
          t = this.messagesCommon;
      return e.closeButton ? C("div", {
        role: "button",
        tabIndex: 0,
        bind: this,
        onclick: this._close,
        onkeydown: this._close,
        class: T.button,
        "aria-label": t.close,
        title: t.close,
        afterCreate: this._closeButtonNodeUpdated,
        afterUpdate: this._closeButtonNodeUpdated
      }, this.renderCloseIcon()) : null;
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      return C("header", {
        class: T.header
      }, this.renderTitle(), C("div", {
        class: T.headerButtons
      }, this.renderDockButton(), this.renderCloseButton()));
    }
  }, {
    key: "renderContentContainer",
    value: function renderContentContainer() {
      var e = this.contentId,
          t = this.hasContent,
          i = this.contentCollapsed,
          o = this.viewModel.content;
      return t && !i ? C("article", {
        key: o,
        enterAnimation: this._createFeatureUpdatedAnimation(),
        id: e,
        class: T.content
      }, this.renderContent()) : null;
    }
  }, {
    key: "renderActionsMenuButton",
    value: function renderActionsMenuButton() {
      var e = this.actionsMenuId,
          t = this.actionsMenuButtonId,
          i = this.actionsMenuOpen,
          o = this.dividedActions,
          n = this.messagesCommon,
          s = i ? n.close : n.open,
          r = o.menuActions;
      return r.length ? C("div", {
        key: P("actions-menu-button"),
        class: this.classes(T.button, T.actionsMenuButton),
        role: "button",
        id: t,
        "aria-haspopup": "true",
        "aria-controls": i ? e : null,
        tabIndex: 0,
        bind: this,
        onclick: this._toggleActionsMenu,
        onkeydown: this._toggleActionsMenu,
        afterCreate: this._focusActionsMenuButtonNode,
        afterUpdate: this._focusActionsMenuButtonNode,
        "aria-label": s,
        title: s
      }, C("span", {
        "aria-hidden": "true",
        class: T.iconActionsMenu
      })) : null;
    }
  }, {
    key: "renderMenuActions",
    value: function renderMenuActions() {
      var _this2 = this;

      var e = this.actionsMenuId,
          t = this.actionsMenuButtonId,
          i = this.actionsMenuOpen,
          o = this.dividedActions,
          n = o.menuActions;
      return n.length && i ? C("ul", {
        id: e,
        role: "menu",
        "aria-labelledby": t,
        key: P("actions"),
        class: T.actions,
        bind: this,
        onkeyup: this._handleActionMenuKeyup,
        afterCreate: this._actionsMenuNodeUpdated,
        afterUpdate: this._actionsMenuNodeUpdated
      }, n.toArray().map(function (e) {
        return _this2.renderAction({
          action: e,
          type: "menu-item"
        });
      })) : null;
    }
  }, {
    key: "renderInlineActions",
    value: function renderInlineActions() {
      var _this3 = this;

      var e = this.dividedActions.inlineActions;
      return !!e.length && e.toArray().map(function (e) {
        return _this3.renderAction({
          action: e,
          type: "inline"
        });
      });
    }
  }, {
    key: "renderInlineActionsContainer",
    value: function renderInlineActionsContainer() {
      var _this$dividedActions = this.dividedActions,
          e = _this$dividedActions.inlineActions,
          t = _this$dividedActions.menuActions,
          i = !!e.length,
          o = !!t.length;
      return i || o ? C("div", {
        key: "inline-actions-container",
        "data-inline-actions": i.toString(),
        "data-menu-actions": o.toString(),
        class: T.inlineActionsContainer
      }, this.renderInlineActions(), this.renderActionsMenuButton(), this.renderMenuActions()) : null;
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      return this.featureNavigationVisible ? C("section", {
        key: P("navigation"),
        class: this.classes(T.navigation)
      }, this.renderNavigationButtons()) : null;
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      var _r;

      var e = this.featureNavigationVisible,
          t = this.dividedActions,
          i = t.inlineActions,
          o = t.menuActions,
          n = !!i.length,
          s = !!o.length,
          r = (_r = {}, _defineProperty(_r, T.footerHasPagination, e), _defineProperty(_r, T.footerHasActions, n), _defineProperty(_r, T.footerHasActionsMenu, s), _r);
      return e || n ? C("div", {
        key: P("feature-buttons"),
        class: this.classes(T.footer, r)
      }, this.renderInlineActionsContainer(), this.renderNavigation()) : null;
    }
  }, {
    key: "renderFeatureMenuContainer",
    value: function renderFeatureMenuContainer() {
      var e = this.messages,
          _this$viewModel2 = this.viewModel,
          t = _this$viewModel2.featureViewModels,
          i = _this$viewModel2.isLoadingFeature,
          o = O(e.selectedFeatures, {
        total: t.length
      });
      return C("section", {
        key: P("menu"),
        class: T.featureMenu
      }, C("strong", {
        class: T.featureMenuHeader
      }, o), C("nav", {
        bind: this,
        class: T.featureMenuViewport,
        "data-node-ref": "_featureMenuViewportNode",
        afterCreate: F
      }, this.renderFeatureMenu(), C("div", {
        class: T.featureMenuObserver,
        bind: this,
        afterCreate: this._featureMenuIntersectionObserverCreated
      }), i ? C("div", {
        class: T.featureMenuLoader
      }, this.renderLoadingIcon()) : null));
    }
  }, {
    key: "renderPointer",
    value: function renderPointer() {
      return this.dockEnabled ? null : C("div", {
        key: P("pointer"),
        class: T.pointer,
        role: "presentation"
      }, C("div", {
        class: this.classes(T.pointerDirection, T.shadow)
      }));
    }
  }, {
    key: "renderMainContainer",
    value: function renderMainContainer() {
      var _p;

      var e = this.dockEnabled,
          t = this.currentAlignment,
          i = this.currentDockPosition,
          o = this.titleId,
          n = this.contentId,
          s = this.collapsible,
          r = this.hasContent,
          a = this.contentCollapsed,
          l = this.visibleElements,
          u = this.viewModel.title,
          c = "bottom-left" === t || "bottom-center" === t || "bottom-right" === t || "top-left" === i || "top-center" === i || "top-right" === i,
          d = "top-left" === t || "top-center" === t || "top-right" === t || "bottom-left" === i || "bottom-center" === i || "bottom-right" === i,
          p = (_p = {}, _defineProperty(_p, T.shadow, e), _defineProperty(_p, T.isCollapsible, s), _defineProperty(_p, T.isCollapsed, a), _p);
      return C("div", {
        class: this.classes(T.main, T.widget, p),
        tabIndex: l.closeButton ? null : -1,
        role: "dialog",
        "aria-labelledby": u ? o : "",
        "aria-describedby": r && !a ? n : "",
        bind: this,
        onkeyup: this._handleMainKeyup,
        afterCreate: this._mainContainerNodeUpdated,
        afterUpdate: this._mainContainerNodeUpdated
      }, c ? this.renderFooter() : null, c ? this.renderFeatureMenuContainer() : null, this.renderHeader(), this.renderContentContainer(), d ? this.renderFooter() : null, d ? this.renderFeatureMenuContainer() : null);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var e;
      var t = null == (e = this.viewModel) ? void 0 : e.content;
      return t ? "string" == typeof t ? C("div", {
        key: t,
        innerHTML: t
      }) : this.renderNodeContent(t) : null;
    }
  }, {
    key: "renderActionText",
    value: function renderActionText(e) {
      return C("span", {
        key: "text",
        class: T.actionText
      }, e);
    }
  }, {
    key: "renderActionIcon",
    value: function renderActionIcon(e) {
      var _o;

      var t = this._getActionClass(e),
          i = this._getActionImage(e),
          o = (_o = {}, _defineProperty(_o, T.iconLoading, e.active), _defineProperty(_o, T.rotating, e.active), _defineProperty(_o, T.icon, !!t), _defineProperty(_o, T.actionImage, !e.active && !!i), _o);

      return t && (o[t] = !e.active), C("span", {
        key: "icon",
        "aria-hidden": "true",
        class: this.classes(T.icon, o),
        styles: this._getIconStyles(i)
      });
    }
  }, {
    key: "renderAction",
    value: function renderAction(e) {
      var _n;

      var t = e.action,
          i = e.type,
          o = this._getActionTitle(t),
          n = (_n = {}, _defineProperty(_n, T.action, "toggle" !== t.type), _defineProperty(_n, T.actionToggle, "toggle" === t.type), _defineProperty(_n, T.actionToggleOn, "toggle" === t.type && t.value), _defineProperty(_n, T.buttonDisabled, t.disabled), _n),
          s = [this.renderActionIcon(t), this.renderActionText(o)],
          r = "menu-item" === i ? C("li", {
        key: t.uid,
        role: "menuitem",
        tabIndex: 0,
        title: o,
        "aria-label": o,
        class: this.classes(T.button, n),
        onkeyup: this._handleActionMenuItemKeyup,
        bind: this,
        "data-action-uid": t.uid,
        onclick: this._triggerAction,
        onkeydown: this._triggerAction
      }, s) : C("div", {
        key: t.uid,
        role: "button",
        tabIndex: 0,
        title: o,
        "aria-label": o,
        class: this.classes(T.button, n),
        onkeyup: this._handleActionMenuItemKeyup,
        bind: this,
        "data-action-uid": t.uid,
        onclick: this._triggerAction,
        onkeydown: this._triggerAction
      }, s);

      return t.visible ? r : null;
    }
  }, {
    key: "renderFeatureMenuItem",
    value: function renderFeatureMenuItem(e, t) {
      var i = this.messages,
          o = this.messagesCommon,
          _this$viewModel3 = this.viewModel,
          n = _this$viewModel3.selectedFeatureIndex,
          s = _this$viewModel3.selectedFeatureViewModel,
          r = e === s,
          a = _defineProperty({}, T.featureMenuSelected, r),
          l = r ? C("span", {
        key: P("feature-menu-selected-feature-".concat(n)),
        title: i.selectedFeature,
        "aria-label": i.selectedFeature,
        class: T.iconCheckMark
      }) : null,
          u = C("span", {
        innerHTML: e.title || o.untitled
      });

      return C("li", {
        role: "menuitem",
        tabIndex: -1,
        key: P("feature-menu-feature-".concat(n)),
        class: this.classes(a, T.featureMenuItem),
        bind: this,
        "data-feature-index": t,
        onkeyup: this._handleFeatureMenuItemKeyup,
        onclick: this._selectFeature,
        onkeydown: this._selectFeature
      }, C("span", {
        class: T.featureMenuTitle
      }, u, l));
    }
  }, {
    key: "renderFeatureMenu",
    value: function renderFeatureMenu() {
      var _this4 = this;

      var e = this.featureMenuId,
          t = this.viewModel.featureViewModels;
      return t.length > 1 ? C("ol", {
        class: T.featureMenuList,
        id: e,
        bind: this,
        afterCreate: this._featureMenuNodeUpdated,
        afterUpdate: this._featureMenuNodeUpdated,
        onkeyup: this._handleFeatureMenuKeyup,
        role: "menu"
      }, t.filter(function (e) {
        return !!e.graphic;
      }).map(function (e, t) {
        return _this4.renderFeatureMenuItem(e, t);
      })) : null;
    }
  }, {
    key: "_getActionTitle",
    value: function _getActionTitle(e) {
      var t = this.messages,
          i = this.selectedFeature,
          o = this.messagesCommon,
          n = e.id,
          s = null == i ? void 0 : i.attributes,
          r = "zoom-to-feature" === n ? O(e.title, {
        messages: t
      }) : "remove-selected-feature" === n ? O(e.title, {
        messages: o
      }) : "zoom-to-clustered-features" === n || "browse-clustered-features" === n ? O(e.title, {
        messages: t
      }) : e.title;
      return r && s ? O(r, s) : r;
    }
  }, {
    key: "_getActionClass",
    value: function _getActionClass(e) {
      var t = this.selectedFeature,
          i = null == t ? void 0 : t.attributes,
          o = e.className,
          n = e.image,
          s = n || o ? o : T.iconDefaultAction;
      return s && i ? O(s, i) : s;
    }
  }, {
    key: "_getActionImage",
    value: function _getActionImage(e) {
      var t = this.selectedFeature,
          i = null == t ? void 0 : t.attributes,
          o = e.image;
      return o && i ? O(o, i) : o;
    }
  }, {
    key: "_createFeatureUpdatedAnimation",
    value: function _createFeatureUpdatedAnimation() {
      return I("enter", T.hasFeatureUpdated);
    }
  }, {
    key: "_getInlineActionCount",
    value: function _getInlineActionCount() {
      var e = this.maxInlineActions,
          t = this.featureNavigationVisible;
      if ("number" != typeof e) return null;
      var i = Math.round(e);
      return Math.max(t ? i - 1 : i, 0);
    }
  }, {
    key: "_watchActions",
    value: function _watchActions() {
      var _this5 = this;

      var e = this.viewModel.allActions;
      this.notifyChange("dividedActions");
      var t = "actions";
      this._handles.remove(t), e && e.forEach(function (e) {
        _this5._handles.add(a(e, ["uid", "active", "className", "disabled", "id", "title", "image", "visible"], function () {
          return _this5.scheduleRender();
        }), t);
      });
    }
  }, {
    key: "_divideActions",
    value: function _divideActions() {
      var e = this.viewModel.allActions,
          i = e.filter(function (e) {
        return e.visible;
      }),
          o = this._getInlineActionCount(),
          n = null === o,
          s = 0 === o;

      return {
        inlineActions: n ? i.slice(0) : s ? new t() : i.slice(0, o),
        menuActions: n ? new t() : s ? i.slice(0) : i.slice(o)
      };
    }
  }, {
    key: "_featureMenuOpenChanged",
    value: function _featureMenuOpenChanged(e) {
      e ? this._focusFirstFeature = !0 : this._focusFeatureMenuButton = !0;
    }
  }, {
    key: "_actionsMenuOpenChanged",
    value: function _actionsMenuOpenChanged(e) {
      e ? this._focusFirstAction = !0 : this._focusActionsMenuButton = !0;
    }
  }, {
    key: "_setTitleFromFeatureWidget",
    value: function _setTitleFromFeatureWidget() {
      var e = this.selectedFeatureWidget,
          t = this.messagesCommon;
      var i, o;
      e && (this.viewModel.title = "error" === (null == (i = e.viewModel) ? void 0 : i.state) ? t.errorMessage : (null == (o = e.viewModel) ? void 0 : o.title) || "");
    }
  }, {
    key: "_setContentFromFeatureWidget",
    value: function _setContentFromFeatureWidget() {
      var e = this.selectedFeatureWidget;
      e && (this.viewModel.content = e);
    }
  }, {
    key: "_unobserveFeatureMenuObserver",
    value: function _unobserveFeatureMenuObserver() {
      this._featureMenuIntersectionObserverNode && this._featureMenuIntersectionObserver.unobserve(this._featureMenuIntersectionObserverNode);
    }
  }, {
    key: "_featureMenuIntersectionObserverCreated",
    value: function _featureMenuIntersectionObserverCreated(e) {
      this._unobserveFeatureMenuObserver(), this._featureMenuIntersectionObserver.observe(e), this._featureMenuIntersectionObserverNode = e;
    }
  }, {
    key: "_handleFeatureMenuKeyup",
    value: function _handleFeatureMenuKeyup(e) {
      "Escape" === i(e) && (e.stopPropagation(), this._focusFeatureMenuButton = !0, this.featureMenuOpen = !1, this.scheduleRender());
    }
  }, {
    key: "_handleActionMenuKeyup",
    value: function _handleActionMenuKeyup(e) {
      "Escape" === i(e) && (e.stopPropagation(), this._focusActionsMenuButton = !0, this.actionsMenuOpen = !1, this.scheduleRender());
    }
  }, {
    key: "_handleFeatureMenuItemKeyup",
    value: function _handleFeatureMenuItemKeyup(e) {
      var t = i(e),
          o = this._featureMenuNode,
          n = e.currentTarget["data-feature-index"];
      if (!o) return;
      var s = o.querySelectorAll("li"),
          r = s.length;
      if ("ArrowUp" !== t) {
        if ("ArrowDown" !== t) {
          if ("Home" !== t) {
            if ("End" !== t) ;else {
              e.stopPropagation();
              s[s.length - 1].focus();
            }
          } else {
            e.stopPropagation();
            s[0].focus();
          }
        } else {
          e.stopPropagation();
          s[(n + 1 + r) % r].focus();
        }
      } else {
        e.stopPropagation();
        s[(n - 1 + r) % r].focus();
      }
    }
  }, {
    key: "_handleActionMenuItemKeyup",
    value: function _handleActionMenuItemKeyup(e) {
      var t = i(e),
          o = this._actionsMenuNode,
          n = e.currentTarget.dataset.actionUid,
          s = this.dividedActions.menuActions,
          r = s.findIndex(function (e) {
        return e.uid === n;
      });
      if (!o) return;
      var a = o.querySelectorAll("li"),
          l = a.length;
      if ("ArrowUp" !== t) {
        if ("ArrowDown" !== t) {
          if ("Home" !== t) {
            if ("End" !== t) ;else {
              e.stopPropagation();
              a[a.length - 1].focus();
            }
          } else {
            e.stopPropagation();
            a[0].focus();
          }
        } else {
          e.stopPropagation();
          a[(r + 1 + l) % l].focus();
        }
      } else {
        e.stopPropagation();
        a[(r - 1 + l) % l].focus();
      }
    }
  }, {
    key: "_handleMainKeyup",
    value: function _handleMainKeyup(e) {
      var t = i(e);
      "ArrowLeft" === t && (e.stopPropagation(), this.previous()), "ArrowRight" === t && (e.stopPropagation(), this.next());
    }
  }, {
    key: "_spinnerEnabledChange",
    value: function _spinnerEnabledChange(e) {
      if (this._destroySpinner(), !e) return;
      var t = this.get("viewModel.view");

      this._createSpinner(t);
    }
  }, {
    key: "_hideSpinner",
    value: function _hideSpinner() {
      var e = this._spinner;
      e && (e.location = null, e.hide());
    }
  }, {
    key: "_displaySpinner",
    value: function _displaySpinner() {
      var e = this._spinner;
      if (!e) return;
      var _this$viewModel4 = this.viewModel,
          t = _this$viewModel4.location,
          i = _this$viewModel4.waitingForResult;
      i ? e.show({
        location: t
      }) : e.hide();
    }
  }, {
    key: "_getIconStyles",
    value: function _getIconStyles(e) {
      return {
        "background-image": e ? "url(".concat(e, ")") : ""
      };
    }
  }, {
    key: "_addSelectedFeatureIndexHandle",
    value: function _addSelectedFeatureIndexHandle() {
      var _this6 = this;

      var e = a(this, "viewModel.selectedFeatureIndex", function (e, t) {
        return _this6._selectedFeatureIndexUpdated(e, t);
      });

      this._handles.add(e, x);
    }
  }, {
    key: "_selectedFeatureIndexUpdated",
    value: function _selectedFeatureIndexUpdated(e, t) {
      var i = this.featureCount;
      i && e !== t && -1 !== e && (this.actionsMenuOpen = !1, this.featureMenuOpen = !1);
    }
  }, {
    key: "_destroySelectedFeatureWidget",
    value: function _destroySelectedFeatureWidget() {
      var e = this._feature;
      e && (e.viewModel = null, e && !e.destroyed && e.destroy()), this._feature = null;
    }
  }, {
    key: "_isScreenLocationWithinView",
    value: function _isScreenLocationWithinView(e, t) {
      return e.x > -1 && e.y > -1 && e.x <= t.width && e.y <= t.height;
    }
  }, {
    key: "_isOutsideView",
    value: function _isOutsideView(e) {
      var t = e.popupHeight,
          i = e.popupWidth,
          o = e.screenLocation,
          n = e.side,
          s = e.view;
      if (isNaN(i) || isNaN(t) || !s || !o) return !1;
      var r = s.padding;
      return "right" === n && o.x + i / 2 > s.width - r.right || "left" === n && o.x - i / 2 < r.left || "top" === n && o.y - t < r.top || "bottom" === n && o.y + t > s.height - r.bottom;
    }
  }, {
    key: "_calculateAutoAlignment",
    value: function _calculateAutoAlignment(e) {
      if ("auto" !== e) return e;
      var t = this._pointerOffsetInPx,
          i = this._containerNode,
          o = this._mainContainerNode,
          n = this.viewModel,
          r = n.screenLocation,
          a = n.view;
      if (s(r) || !a || !i) return "top-center";
      if (!this._isScreenLocationWithinView(r, a)) return this._get("currentAlignment") || "top-center";

      function l(e) {
        return parseInt(e.replace(/[^-\d\.]/g, ""), 10);
      }

      var u = o ? window.getComputedStyle(o, null) : null,
          c = u ? l(u.getPropertyValue("max-height")) : 0,
          d = u ? l(u.getPropertyValue("height")) : 0,
          _i$getBoundingClientR = i.getBoundingClientRect(),
          p = _i$getBoundingClientR.height,
          h = _i$getBoundingClientR.width,
          g = h + t,
          _ = Math.max(p, c, d) + t,
          f = this._isOutsideView({
        popupHeight: _,
        popupWidth: g,
        screenLocation: r,
        side: "right",
        view: a
      }),
          v = this._isOutsideView({
        popupHeight: _,
        popupWidth: g,
        screenLocation: r,
        side: "left",
        view: a
      }),
          m = this._isOutsideView({
        popupHeight: _,
        popupWidth: g,
        screenLocation: r,
        side: "top",
        view: a
      }),
          b = this._isOutsideView({
        popupHeight: _,
        popupWidth: g,
        screenLocation: r,
        side: "bottom",
        view: a
      });

      return v ? m ? "bottom-right" : "top-right" : f ? m ? "bottom-left" : "top-left" : m ? b ? "top-center" : "bottom-center" : "top-center";
    }
  }, {
    key: "_callCurrentAlignment",
    value: function _callCurrentAlignment(e) {
      return "function" == typeof e ? e.call(this) : e;
    }
  }, {
    key: "_getCurrentAlignment",
    value: function _getCurrentAlignment() {
      var e = this.alignment,
          t = this.dockEnabled;
      return t || !this.viewModel.active ? null : this._calculatePositionResult(this._calculateAutoAlignment(this._callCurrentAlignment(e)));
    }
  }, {
    key: "_setCurrentAlignment",
    value: function _setCurrentAlignment() {
      this._set("currentAlignment", this._getCurrentAlignment());
    }
  }, {
    key: "_setCurrentDockPosition",
    value: function _setCurrentDockPosition() {
      this._set("currentDockPosition", this._getCurrentDockPosition());
    }
  }, {
    key: "_calculatePositionResult",
    value: function _calculatePositionResult(e) {
      var t = ["left", "right"];
      return A(this.container) && t.reverse(), e.replace(/leading/gi, t[0]).replace(/trailing/gi, t[1]);
    }
  }, {
    key: "_callDockPosition",
    value: function _callDockPosition(e) {
      return "function" == typeof e ? e.call(this) : e;
    }
  }, {
    key: "_getDockPosition",
    value: function _getDockPosition() {
      var e;
      return this._calculatePositionResult(this._calculateAutoDockPosition(this._callDockPosition(null == (e = this.dockOptions) ? void 0 : e.position)));
    }
  }, {
    key: "_getCurrentDockPosition",
    value: function _getCurrentDockPosition() {
      return this.dockEnabled && this.viewModel.active ? this._getDockPosition() : null;
    }
  }, {
    key: "_wouldDockTo",
    value: function _wouldDockTo() {
      return this.dockEnabled ? null : this._getDockPosition();
    }
  }, {
    key: "_calculateAutoDockPosition",
    value: function _calculateAutoDockPosition(e) {
      var t;
      if ("auto" !== e) return e;
      var i = null == (t = this.viewModel) ? void 0 : t.view,
          o = A(this.container) ? "top-left" : "top-right";
      if (!i) return o;
      var n = i.padding || {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
          s = i.width - n.left - n.right,
          r = i.breakpoints;
      return r && s <= r.xsmall ? "bottom-center" : o;
    }
  }, {
    key: "_positionContainer",
    value: function _positionContainer() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._containerNode;
      if (e && (this._containerNode = e), !e) return;

      var t = this.viewModel.screenLocation,
          _e$getBoundingClientR = e.getBoundingClientRect(),
          i = _e$getBoundingClientR.width,
          o = this._calculatePositionStyle(t, i);

      o && (e.style.top = o.top, e.style.left = o.left, e.style.bottom = o.bottom, e.style.right = o.right);
    }
  }, {
    key: "_calculateFullWidth",
    value: function _calculateFullWidth(e) {
      var t = this.currentAlignment,
          i = this._pointerOffsetInPx;
      return "top-left" === t || "bottom-left" === t || "top-right" === t || "bottom-right" === t ? e + i : e;
    }
  }, {
    key: "_calculateAlignmentPosition",
    value: function _calculateAlignmentPosition(e, t, i, o) {
      var n = this.currentAlignment,
          s = this._pointerOffsetInPx,
          r = o / 2,
          a = i.height - t,
          l = i.width - e,
          u = this.view.padding;
      return "bottom-center" === n ? {
        top: t + s - u.top,
        left: e - r - u.left
      } : "top-left" === n ? {
        bottom: a + s - u.bottom,
        right: l + s - u.right
      } : "bottom-left" === n ? {
        top: t + s - u.top,
        right: l + s - u.right
      } : "top-right" === n ? {
        bottom: a + s - u.bottom,
        left: e + s - u.left
      } : "bottom-right" === n ? {
        top: t + s - u.top,
        left: e + s - u.left
      } : "top-center" === n ? {
        bottom: a + s - u.bottom,
        left: e - r - u.left
      } : void 0;
    }
  }, {
    key: "_calculatePositionStyle",
    value: function _calculatePositionStyle(e, t) {
      var i = this.dockEnabled,
          o = this.view;
      if (!o) return;
      if (i) return {
        left: "",
        top: "",
        right: "",
        bottom: ""
      };
      if (s(e) || !t) return;

      var n = this._calculateFullWidth(t),
          r = this._calculateAlignmentPosition(e.x, e.y, o, n);

      return r ? {
        top: void 0 !== r.top ? "".concat(r.top, "px") : "auto",
        left: void 0 !== r.left ? "".concat(r.left, "px") : "auto",
        bottom: void 0 !== r.bottom ? "".concat(r.bottom, "px") : "auto",
        right: void 0 !== r.right ? "".concat(r.right, "px") : "auto"
      } : void 0;
    }
  }, {
    key: "_viewChange",
    value: function _viewChange(e, t) {
      e && t && (this.close(), this.clear());
    }
  }, {
    key: "_viewReadyChange",
    value: function _viewReadyChange(e, t) {
      if (e) {
        var _e = this.get("viewModel.view");

        this._wireUpView(_e);
      } else t && (this.close(), this.clear());
    }
  }, {
    key: "_wireUpView",
    value: function _wireUpView(e) {
      if (this._destroySpinner(), !e) return;
      var t = this.spinnerEnabled;
      t && this._createSpinner(e), this._setDockEnabledForViewSize(this.dockOptions);
    }
  }, {
    key: "_dockingThresholdCrossed",
    value: function _dockingThresholdCrossed(e, t, i) {
      var _e2 = _slicedToArray(e, 2),
          o = _e2[0],
          n = _e2[1],
          _t3 = _slicedToArray(t, 2),
          s = _t3[0],
          r = _t3[1],
          a = i.width,
          l = i.height;

      return o <= a && s > a || o > a && s <= a || n <= l && r > l || n > l && r <= l;
    }
  }, {
    key: "_updateDockEnabledForViewSize",
    value: function _updateDockEnabledForViewSize(e, t) {
      if (!e || !t) return;
      var i = this.get("viewModel.view.padding") || {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
          o = i.left + i.right,
          n = i.top + i.bottom,
          s = [],
          r = [];
      s[0] = e[0] - o, s[1] = e[1] - n, r[0] = t[0] - o, r[1] = t[1] - n;
      var a = this.dockOptions,
          l = a.breakpoint;
      this._dockingThresholdCrossed(s, r, l) && this._setDockEnabledForViewSize(a), this._setCurrentDockPosition();
    }
  }, {
    key: "_focusDockButtonNode",
    value: function _focusDockButtonNode(e) {
      this._focusDockButton && (this._focusDockButton = !1, e.focus());
    }
  }, {
    key: "_closeButtonNodeUpdated",
    value: function _closeButtonNodeUpdated(e) {
      return this._focusClose ? (this._focusClose = !1, void e.focus()) : this._blurClose ? (this._blurClose = !1, void e.blur()) : void 0;
    }
  }, {
    key: "_mainContainerNodeUpdated",
    value: function _mainContainerNodeUpdated(e) {
      return this._mainContainerNode = e, this._focusContainer ? (this._focusContainer = !1, void e.focus()) : this._blurContainer ? (this._blurContainer = !1, void e.blur()) : void 0;
    }
  }, {
    key: "_featureMenuNodeUpdated",
    value: function _featureMenuNodeUpdated(e) {
      if (this._featureMenuNode = e, !e || !this._focusFirstFeature) return;
      this._focusFirstFeature = !1;
      var t = e.querySelectorAll("li");

      if (t.length) {
        t[0].focus();
      }
    }
  }, {
    key: "_actionsMenuNodeUpdated",
    value: function _actionsMenuNodeUpdated(e) {
      if (this._actionsMenuNode = e, !e || !this._focusFirstAction) return;
      this._focusFirstAction = !1;
      var t = e.querySelectorAll("li");

      if (t.length) {
        t[0].focus();
      }
    }
  }, {
    key: "_focusFeatureMenuButtonNode",
    value: function _focusFeatureMenuButtonNode(e) {
      this._focusFeatureMenuButton && (this._focusFeatureMenuButton = !1, e.focus());
    }
  }, {
    key: "_focusActionsMenuButtonNode",
    value: function _focusActionsMenuButtonNode(e) {
      this._focusActionsMenuButton && (this._focusActionsMenuButton = !1, e.focus());
    }
  }, {
    key: "_featureMenuViewportScrollTop",
    value: function _featureMenuViewportScrollTop() {
      this._featureMenuViewportNode && (this._featureMenuViewportNode.scrollTop = 0);
    }
  }, {
    key: "_toggleScreenLocationEnabled",
    value: function _toggleScreenLocationEnabled() {
      var e = this.dockEnabled,
          t = this.viewModel;
      if (!t) return;
      var i = t.active && !e;
      t.screenLocationEnabled = i;
    }
  }, {
    key: "_shouldDockAtCurrentViewSize",
    value: function _shouldDockAtCurrentViewSize(e) {
      var t, i;
      var o = e.breakpoint,
          n = null == (t = this.viewModel) || null == (i = t.view) ? void 0 : i.ui;
      if (!n) return !1;
      var s = n.width,
          r = n.height;
      if (isNaN(s) || isNaN(r)) return !1;
      var a = o.hasOwnProperty("width") && s <= o.width,
          l = o.hasOwnProperty("height") && r <= o.height;
      return a || l;
    }
  }, {
    key: "_setDockEnabledForViewSize",
    value: function _setDockEnabledForViewSize(e) {
      e.breakpoint && (this.dockEnabled = this._shouldDockAtCurrentViewSize(e));
    }
  }, {
    key: "_getPageText",
    value: function _getPageText(e, t) {
      return this.featureNavigationVisible ? O(this.messages.pageText, {
        index: t + 1,
        total: e
      }) : null;
    }
  }, {
    key: "_destroySpinner",
    value: function _destroySpinner() {
      var e = this._spinner,
          t = this.view;
      e && (t && t.ui && t.ui.remove(this._spinner, B), e.destroy(), this._spinner = null);
    }
  }, {
    key: "_createSpinner",
    value: function _createSpinner(e) {
      e && (this._spinner = new f({
        view: e
      }), e.ui.add(this._spinner, {
        key: B,
        position: "manual"
      }));
    }
  }, {
    key: "_toggleCollapsed",
    value: function _toggleCollapsed() {
      this.collapsed = !this.collapsed;
    }
  }, {
    key: "_close",
    value: function _close() {
      this.close(), this.view && this.view.focus();
    }
  }, {
    key: "_toggleDockEnabled",
    value: function _toggleDockEnabled() {
      this.dockEnabled = !this.dockEnabled, this._focusDockButton = !0, this.scheduleRender();
    }
  }, {
    key: "_toggleFeatureMenu",
    value: function _toggleFeatureMenu() {
      var e = !this.featureMenuOpen;
      this._featureMenuOpenChanged(e), this.actionsMenuOpen = !1, this.featureMenuOpen = e;
    }
  }, {
    key: "_toggleActionsMenu",
    value: function _toggleActionsMenu() {
      var e = !this.actionsMenuOpen;
      this._actionsMenuOpenChanged(e), this.featureMenuOpen = !1, this.actionsMenuOpen = e;
    }
  }, {
    key: "_triggerAction",
    value: function _triggerAction(e) {
      var t = e.currentTarget.dataset.actionUid,
          i = this.viewModel.allActions,
          o = i.findIndex(function (e) {
        return e.uid === t;
      }),
          n = i.getItemAt(o);
      n && "toggle" === n.type && (n.value = !n.value), this.actionsMenuOpen = !1, this.viewModel.triggerAction(o);
    }
  }, {
    key: "_selectFeature",
    value: function _selectFeature(e) {
      var t = e.currentTarget["data-feature-index"];
      isNaN(t) || (this.viewModel.selectedFeatureIndex = t), this.featureMenuOpen = !1, this._focusFeatureMenuButton = !0, this.scheduleRender();
    }
  }, {
    key: "_next",
    value: function _next() {
      this.next();
    }
  }, {
    key: "_previous",
    value: function _previous() {
      this.previous();
    }
  }]);

  return U;
}(m(v));

e([h({
  readOnly: !0
})], U.prototype, "actionsMenuId", null), e([h({
  readOnly: !0
})], U.prototype, "actionsMenuButtonId", null), e([h({
  readOnly: !0
})], U.prototype, "featureMenuId", null), e([h({
  readOnly: !0
})], U.prototype, "titleId", null), e([h({
  readOnly: !0
})], U.prototype, "contentId", null), e([h({
  readOnly: !0
})], U.prototype, "hasContent", null), e([h({
  readOnly: !0
})], U.prototype, "featureNavigationVisible", null), e([h({
  readOnly: !0
})], U.prototype, "collapsible", null), e([h({
  readOnly: !0
})], U.prototype, "featureMenuVisible", null), e([h({
  readOnly: !0
})], U.prototype, "contentCollapsed", null), e([h({
  readOnly: !0
})], U.prototype, "dividedActions", null), e([d("viewModel.actions")], U.prototype, "actions", void 0), e([h()], U.prototype, "actionsMenuOpen", null), e([h()], U.prototype, "alignment", void 0), e([d("viewModel.autoCloseEnabled")], U.prototype, "autoCloseEnabled", void 0), e([d("viewModel.autoOpenEnabled")], U.prototype, "autoOpenEnabled", void 0), e([d("viewModel.defaultPopupTemplateEnabled")], U.prototype, "defaultPopupTemplateEnabled", void 0), e([d("viewModel.content")], U.prototype, "content", void 0), e([h()], U.prototype, "collapsed", void 0), e([h()], U.prototype, "collapseEnabled", void 0), e([h({
  readOnly: !0
})], U.prototype, "currentAlignment", null), e([h({
  readOnly: !0
})], U.prototype, "currentDockPosition", null), e([h()], U.prototype, "dockOptions", null), e([h()], U.prototype, "dockEnabled", void 0), e([d("viewModel.featureCount")], U.prototype, "featureCount", void 0), e([h()], U.prototype, "featureMenuOpen", void 0), e([d("viewModel.features")], U.prototype, "features", void 0), e([d("viewModel.goToOverride")], U.prototype, "goToOverride", void 0), e([h()], U.prototype, "headingLevel", void 0), e([d("viewModel.highlightEnabled")], U.prototype, "highlightEnabled", void 0), e([d("viewModel.location")], U.prototype, "location", void 0), e([h({
  aliasOf: {
    source: "messages.widgetLabel",
    overridable: !0
  }
})], U.prototype, "label", void 0), e([h()], U.prototype, "maxInlineActions", void 0), e([h(), y("esri/widgets/Popup/t9n/Popup")], U.prototype, "messages", void 0), e([h(), y("esri/t9n/common")], U.prototype, "messagesCommon", void 0), e([d("viewModel.promises")], U.prototype, "promises", void 0), e([d("viewModel.selectedFeature")], U.prototype, "selectedFeature", void 0), e([d("viewModel.selectedFeatureIndex")], U.prototype, "selectedFeatureIndex", void 0), e([h({
  readOnly: !0
})], U.prototype, "selectedFeatureWidget", null), e([h()], U.prototype, "spinnerEnabled", void 0), e([d("viewModel.title")], U.prototype, "title", void 0), e([d("viewModel.updateLocationEnabled")], U.prototype, "updateLocationEnabled", void 0), e([d("viewModel.view")], U.prototype, "view", void 0), e([h({
  type: b
}), k(["triggerAction", "trigger-action"])], U.prototype, "viewModel", void 0), e([d("viewModel.visible")], U.prototype, "visible", void 0), e([h()], U.prototype, "visibleElements", void 0), e([p("visibleElements")], U.prototype, "castVisibleElements", null), e([w()], U.prototype, "_close", null), e([w()], U.prototype, "_toggleDockEnabled", null), e([w()], U.prototype, "_toggleFeatureMenu", null), e([w()], U.prototype, "_toggleActionsMenu", null), e([w()], U.prototype, "_triggerAction", null), e([w()], U.prototype, "_selectFeature", null), e([w()], U.prototype, "_next", null), e([w()], U.prototype, "_previous", null), U = e([g(L)], U);
var R = U;
export { R as default };